const AUTO_TICKETS_VIOLATION = ['license/registration', 'speed', 'FTYROW', 'other'] as const;

export default AUTO_TICKETS_VIOLATION;
